import { render, staticRenderFns } from "./SubMenuBar.vue?vue&type=template&id=5494da0a&scoped=true&"
import script from "./SubMenuBar.vue?vue&type=script&lang=js&"
export * from "./SubMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuBar.vue?vue&type=style&index=0&id=5494da0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494da0a",
  null
  
)

export default component.exports